import(/* webpackMode: "eager" */ "/app/app/globals.css");
import(/* webpackMode: "eager" */ "/app/components/Analytics/UtmCapture.jsx");
import(/* webpackMode: "eager" */ "/app/components/FloatingWidget/FloatingWidget.jsx");
import(/* webpackMode: "eager" */ "/app/components/FloatingWidget/FloatingWidgetContext.jsx");
import(/* webpackMode: "eager" */ "/app/components/Provider.jsx");
import(/* webpackMode: "eager" */ "/app/components/thirdparty/welist/WLAIChat.js");
import(/* webpackMode: "eager" */ "/app/context/LocaleProvider.js");
import(/* webpackMode: "eager" */ "/app/context/ThemeContext.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")